import React, { useState } from 'react';
import { Alert } from 'react-bootstrap';

const AlertDismissible = (props: any) => {
  const [show, setShow] = useState(true);

  const handleClose = (state: boolean) => {
    setShow(false);
    if (props.handleClose) {
      props.handleClose(false);
    }
  };

  if (show) {
    return (
      <Alert className={props.className} variant={props.variant} onClose={handleClose} dismissible>
        {props.children}
      </Alert>
    );
  } else {
    return null;
  }
}
export default AlertDismissible;